<template>
    <div class="home flex w-full flex-col items-center justify-center overflow-x-clip px-6 [overflow-clip-margin:1.5rem] 4xl:mb-24" :class="{ 'is-waiting': !isReady }">
        <disc-hero @ready="isReady = true" />

        <div class="mt-6 text-center md:mt-9">
            <h1 class="page-title animate-text-reveal text-4xl [animation-delay:700ms] md:text-6xl">
                Dreamless Water
            </h1>

            <div class="animate-text-reveal text-xs uppercase tracking-[0.8em] text-foam/60 [animation-delay:900ms]">
                Funus
            </div>
        </div>

        <div class="mt-6 flex animate-text-reveal justify-center [animation-delay:1300ms]">
            <button type="button" class="btn-ghost relative gap-3 overflow-hidden" :aria-label="isPlaying ? 'Pause teaser' : 'Play teaser'" @click="togglePlayback">
                <svg class="h-3 w-3 fill-current" viewBox="0 0 12 12" aria-hidden="true">
                    <path v-if="isPlaying" d="M1 0h3.5v12H1zM7.5 0H11v12H7.5z" />
                    <path v-else d="M1.5 0 11 6l-9.5 6z" />
                </svg>

                <span>{{ isPlaying ? 'Pause teaser' : 'Play teaser' }}</span>

                <span
                    class="pointer-events-none absolute bottom-0 left-0 h-px bg-white shadow-[0_0_8px_-1px_oklch(0.91_0.01_240_/_80%)] transition-[width] duration-200 ease-linear"
                    :style="{ width: `${progress}%` }"
                />
            </button>
        </div>

        <div class="mt-10 flex animate-text-reveal flex-wrap justify-center gap-3 sm:gap-6 [animation-delay:1100ms]">
            <router-link :to="{ name: 'releases' }" class="btn-ghost btn-hint">
                Listen
            </router-link>

            <router-link :to="{ name: 'videos' }" class="btn-ghost">
                Watch
            </router-link>

            <router-link :to="{ name: 'shop' }" class="btn-ghost">
                Shop
            </router-link>
        </div>
    </div>
</template>

<script>
    // Components
    import { defineComponent, ref, onBeforeUnmount } from 'vue';
    import DiscHero from '@/components/DiscHero';

    const TEASER_SRC = '/music/Funus-Heavy_Shoegaze-Teaser.mp3';

    export default defineComponent({
        name: 'HomeView',

        components: {
            DiscHero,
        },

        setup() {
            const isReady = ref(false);
            const isPlaying = ref(false);
            const progress = ref(0);
            let teaser = null;

            const togglePlayback = () => {
                if (!teaser) {
                    teaser = new Audio(TEASER_SRC);
                    teaser.addEventListener('play', () => { isPlaying.value = true; });
                    teaser.addEventListener('pause', () => { isPlaying.value = false; });

                    teaser.addEventListener('ended', () => {
                        isPlaying.value = false;
                        progress.value = 0;
                    });

                    teaser.addEventListener('timeupdate', () => {
                        progress.value = teaser.duration ? (teaser.currentTime / teaser.duration) * 100 : 0;
                    });
                }

                if (teaser.paused) {
                    teaser.play();
                } else {
                    teaser.pause();
                }
            };

            onBeforeUnmount(() => {
                if (teaser) {
                    teaser.pause();
                }
            });

            return {
                isReady,
                isPlaying,
                progress,
                togglePlayback,
            };
        },
    });
</script>

<style>
    .home.is-waiting *,
    .home.is-waiting *::before,
    .home.is-waiting *::after {
        animation-play-state: paused;
    }
</style>
